import { useState } from 'react';
import type { DayOfWeek, HoursModule, DayHours } from '@inboundhost/shared';

const DAYS: { key: DayOfWeek; label: string }[] = [
  { key: 'monday', label: 'Monday' },
  { key: 'tuesday', label: 'Tuesday' },
  { key: 'wednesday', label: 'Wednesday' },
  { key: 'thursday', label: 'Thursday' },
  { key: 'friday', label: 'Friday' },
  { key: 'saturday', label: 'Saturday' },
  { key: 'sunday', label: 'Sunday' },
];

const DEFAULT_DAY: DayHours = { closed: false, open: '09:00', close: '17:00' };

function emptyHours(): HoursModule {
  return {
    monday: { ...DEFAULT_DAY },
    tuesday: { ...DEFAULT_DAY },
    wednesday: { ...DEFAULT_DAY },
    thursday: { ...DEFAULT_DAY },
    friday: { ...DEFAULT_DAY },
    saturday: { ...DEFAULT_DAY },
    sunday: { ...DEFAULT_DAY, closed: true },
  };
}

interface Props {
  value: HoursModule | null;
  onSave: (v: HoursModule) => void;
}

export function HoursEditor({ value, onSave }: Props) {
  const [hours, setHours] = useState<HoursModule>(value ?? emptyHours());

  function update(day: DayOfWeek, patch: Partial<DayHours>) {
    setHours({ ...hours, [day]: { ...hours[day], ...patch } });
  }

  return (
    <div className="bg-white rounded shadow p-6">
      <table className="w-full mb-4">
        <tbody>
          {DAYS.map(({ key, label }) => {
            const h = hours[key];
            return (
              <tr key={key} className="border-b last:border-b-0">
                <td className="py-2 font-medium w-32">{label}</td>
                <td className="py-2 w-24">
                  <label className="text-sm flex items-center gap-1">
                    <input
                      type="checkbox"
                      checked={h.closed}
                      onChange={(e) => update(key, { closed: e.target.checked })}
                    />
                    Closed
                  </label>
                </td>
                <td className="py-2">
                  <input
                    type="time"
                    disabled={h.closed}
                    className="border rounded px-2 py-1 disabled:opacity-40"
                    value={h.open ?? '09:00'}
                    onChange={(e) => update(key, { open: e.target.value })}
                  />
                </td>
                <td className="py-2">
                  <input
                    type="time"
                    disabled={h.closed}
                    className="border rounded px-2 py-1 disabled:opacity-40"
                    value={h.close ?? '17:00'}
                    onChange={(e) => update(key, { close: e.target.value })}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <button
        type="button"
        onClick={() => onSave(hours)}
        className="bg-gray-900 text-white px-4 py-1 rounded hover:bg-gray-800"
      >
        Save hours
      </button>
    </div>
  );
}
